
export default function MapSection() {
  return (
    <section className="py-20 bg-gradient-to-b from-lightBlue/5 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-4">
            Visit Our Dallas Office
          </h2>
          <p className="text-lg text-darkGray max-w-3xl mx-auto">
            Conveniently located in the heart of Dallas — stop by for a free consultation
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-8 border border-lightBlue/20 shadow-lg">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-secondary"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-xl text-primary mb-2">Office Address</h3>
                  <p className="text-darkGray leading-relaxed">
                    8300 Douglas Ave Ste 800<br />
                    Dallas, TX 75225
                  </p>
                  <a
                    href="https://maps.google.com/?q=8300+Douglas+Ave+Ste+800+Dallas+TX+75225"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-secondary font-semibold mt-3 hover:gap-3 transition-all cursor-pointer"
                  >
                    <span>Get Directions</span>
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 border border-lightBlue/20 shadow-lg">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-secondary"></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-xl text-primary mb-4">Office Hours</h3>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-darkGray">Monday - Friday</span>
                      <span className="font-semibold text-primary">8:00 AM - 6:00 PM</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-darkGray">Saturday</span>
                      <span className="font-semibold text-primary">9:00 AM - 2:00 PM</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-darkGray">Sunday</span>
                      <span className="font-semibold text-primary">Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 border border-lightBlue/20 shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-parking-box-line text-2xl text-secondary"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-xl text-primary mb-2">Parking Information</h3>
                  <p className="text-darkGray leading-relaxed">
                    Free parking available in the building garage. Visitor parking is located on Level 2. Handicap accessible entrance available.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-2xl border border-lightBlue/20 h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3355.8!2d-96.8!3d32.85!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDUxJzAwLjAiTiA5NsKwNDgnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dallas Health Insurance Experts Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
